import { useEffect, type RefObject } from 'react';
import { useAudioPlayerControls } from './useAudioPlayer';

export function useInlineVisibility(ref: RefObject<HTMLElement | null>) {
  const { setInlineVisible } = useAudioPlayerControls();
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => setInlineVisible(entry.isIntersecting),
      { threshold: 0 },
    );
    observer.observe(el);
    return () => {
      observer.disconnect();
      setInlineVisible(false);
    };
  }, [ref, setInlineVisible]);
}
